import React, { Component } from 'react'
import { css } from 'emotion'
import { CFLink, CFView, CFText, Space, PageHeader } from 'components'
import { hero, downloadButton } from 'images'
import { MEDIA_QUERY } from 'styles'

class Hero extends Component {
  render() {
    const { OrderNowButtonElement } = this.props
    return (
      <div className={styles.container}>
        <PageHeader />
        <CFView column className={styles.text}>
          <CFText heading2 bold h1 color="white">
            Free edamame on your first order!
          </CFText>
        </CFView>
        <CFView className={styles.buttons}>
          {OrderNowButtonElement}
          <Space w2 />
          <div className={styles.downloadButton}>
            <CFLink href="http://onelink.to/qpnqcn">
              <img src={downloadButton} alt="Download App" />
            </CFLink>
          </div>
        </CFView>
      </div>
    )
  }
}
const styles = {
  container: css({
    maxWidth: '160rem',
    height: '100VH',
    width: '100%',
    background: `url(${hero}) no-repeat`,
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center',
    position: 'relative',
    boxShadow: '0 .2rem .4rem rgba(0,0,0,0.7)',
    [MEDIA_QUERY.MD]: {
      backgroundAttachment: 'scroll',
      height: '100vh',
      backgroundPosition: '40%',
    },
  }),
  text: css({
    position: 'absolute',
    bottom: '6%',
    left: '3%',
    backgroundColor: 'rgba(0,0,0,0.7)',
    padding: '1rem 3rem 1rem 3rem',
    borderRadius: '3rem',
    [MEDIA_QUERY.MD]: {
      bottom: '28%',
      left: 'auto',
      padding: '1rem',
      textAlign: 'center',
      margin: '1rem',
    },
  }),
  buttons: css({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: '5%',
    right: '3%',
    [MEDIA_QUERY.MD]: {
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'center',
      bottom: '5%',
      right: 'auto',
    },
  }),
  downloadButton: css({
    transition: 'all .2s',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  }),
  ctaText: css({
    fontSize: 38,
    [MEDIA_QUERY.MD]: {
      display: 'none',
    },
  }),
}

export default Hero
